import { useContext } from 'react'
import { useTranslation } from 'next-i18next'
import PropTypes from 'prop-types'

// Context
import { CalendarContext } from '../../context/CalendarContext'

// Internal Components
import Button from '../Button/Button'
import Svg from '../Svg/Svg'
import CalendarDropdown from '../CalendarDropdown/CalendarDropdown'
import { NavigationContext } from '@/root/context/NavigationContext'
import CalendarOverlay from '../CalendarOverlay/CalendarOverlay'
import { UserContext } from '@/root/context/UserContext'

const CalendarNavigation = () => {
  // Contexts
  const calendarContext = useContext(CalendarContext)
  const userContext = useContext(UserContext)
  const navigationContext = useContext(NavigationContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const matchModeEnabled = userContext.userSession?.matchMode || null

  const onChangeHandler = (e) => {
    const value = e.target.value
    const target = document.querySelector(`[data-month="${value}"]`)

    calendarContext.setSelectedDate(value)
    target?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  return (
    <div className="CalendarNavigation">
      <div className="CalendarNavigation-inner">
        <div className="CalendarNavigation-wrapper">
          <div className="CalendarNavigation-container">
            <ul className="CalendarNavigation-list">
              <li className="CalendarNavigation-item">
                <div className="CalendarNavigation-navMonths">
                  <select
                    className="CalendarNavigation-navSelect"
                    onChange={onChangeHandler}
                    value={calendarContext.selectedDate}
                  >
                    {calendarContext.navigationMonths.map((item, index) => {
                      return (
                        <optgroup label={item?.year} key={`CalendarNavigation-optGroup--${index}`}>
                          {item.months.map((month, monthIndex) => {
                            return (
                              <option
                                value={`${item.year}.${month.index}`}
                                key={`CalendarNavigation-option--${monthIndex}`}
                              >
                                {t(month.label)}
                              </option>
                            )
                          })}
                        </optgroup>
                      )
                    })}
                  </select>
                  <Svg id="icon-chevron-down" modifiers={['CalendarNavigation-icon']} />
                </div>
              </li>
              <li className="CalendarNavigation-item">
                {userContext?.loggedIn && userContext?.userSession?.team && calendarContext.seasonActiveState && (
                  <>
                    {matchModeEnabled ? (
                      <CalendarDropdown />
                    ) : (
                      <Button
                        label={t('CALENDAR_NAV__BTN_ADDBLUEPRINT')}
                        modal={{ type: 'api', route: 'create/blueprint/open' }}
                        icon={{ id: 'icon-add' }}
                        modifiers={['Button--calendarNavigation']}
                      />
                    )}
                  </>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <CalendarOverlay
        show={navigationContext.dropdownOverlay}
        onClick={() => navigationContext.setDropdownOverlay(false)}
      />
    </div>
  )
}

CalendarNavigation.propTypes = {
  currentSection: PropTypes.any
}

export default CalendarNavigation
